import React, { useEffect } from "react";
import { Box, Divider } from "@mui/material";
import { generatePortfolioSEO, updateMetaTags } from "../utils/seo";
import AboutSection from "../components/About";
import Experience from "../components/Experience";
import Projects from "../components/Projects";
import Skills from "../components/Skills";
import Contacts from "../components/Contacts";
import SocialLinks from "../components/SocialLinks";
import Footer from "../components/Footer";

const About: React.FC = () => {
  useEffect(() => {
    const seo = generatePortfolioSEO();
    updateMetaTags(seo);
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Box sx={{ flex: 1, position: "relative" }}>
        <AboutSection />
        <Divider sx={{ my: 4 }} />
        <Experience />
        <Divider sx={{ my: 4 }} />
        <Projects />
        <Divider sx={{ my: 4 }} />
        <Skills />
        <Divider sx={{ my: 4 }} />
        <Contacts />

        {/* Social Links - positioned at bottom center (mobile) or center left (desktop) */}
        <Box
          sx={{
            position: "fixed",
            bottom: { xs: 16, md: "50%" },
            left: { xs: "50%", md: 16 },
            transform: {
              xs: "translateX(-50%)",
              md: "translateY(50%)",
            },
            zIndex: 1000,
          }}
        >
          <SocialLinks />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default About;
